module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.getAppLevelSetting('maskCssTransition') === true) ? _c('div', {
    attrs: {
      "id": "preload_area"
    }
  }, [_c('div', {
    attrs: {
      "id": "mask-nature1"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mask-nature2"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mask-urban1"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mask-urban2"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mask-building1"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mask-building2"
    }
  })]) : _vm._e(), _vm._v(" "), _c('main-container', {
    attrs: {
      "id": "appMainContainer",
      "back-link": _vm.backLink,
      "showTopNav": _vm.showTopNav
    }
  }, [_c('app-page-loading-icon'), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "name": _vm.transitionName,
      "mode": "in-out"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "after-leave": _vm.afterLeave
    }
  }, [_c('keep-alive', [_c('router-view', {
    key: _vm.$route.fullPath,
    staticClass: "view child-view",
    on: {
      "require-back-link": _vm.handleisBackLinkNeeded,
      "show-top-nav": _vm.handleShowTopNav
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.getAppLevelSetting('designDevTools') === true) ? _c('design-dev-tools') : _vm._e()], 1), _vm._v(" "), (_vm.getAppLevelSetting('gsDevTools') === true) ? _c('gs-dev-tools') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7971f6e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 233
// module chunks = 1